<template>
  <el-card shadow="never" class="statistics-card">
    <el-radio-group v-model="tabs" @change="handleChangeType">
      <el-radio-button label="today">今日</el-radio-button>
      <el-radio-button label="yesterday">昨日</el-radio-button>
      <el-radio-button label="week">本周</el-radio-button>
      <el-radio-button label="month">本月</el-radio-button>
      <el-radio-button label="year">今年</el-radio-button>
    </el-radio-group>
    <el-row :gutter="0" style="margin-top: 16px">
      <el-col :span="6">
        <div>{{ titles.total }}</div>
        <div class="body">
          <span class="num">{{ statics.totalOrders || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>{{ titles.done }}</div>
        <div class="body">
          <span class="num">{{ statics.totalDrugs || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import fetch from '@/api';

const type2Datetime = type => {
  switch (type) {
    case 'today': {
      return {
        orderStartTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'yesterday': {
      const yesterday = dayjs().subtract(1, 'days');
      return {
        orderStartTime: yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'week':
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'month':
      return {
        orderStartTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'year':
      return {
        orderStartTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      };
    default:
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
  }
};

export default {
  name: 'staticsCard',
  props: {
    type: {
      type: String,
      // e.g. fourClass special prescription
      default: 'fourClass'
    }
  },
  data() {
    return { tabs: 'today', statics: {} };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    },
    titles() {
      const titleMap = {
        total: '入库订单数',
        done: '入库药品数'
      };

      return titleMap;
    }
  },
  mounted() {
    this.fetchStaticsData();
  },
  methods: {
    handleChangeType() {
      this.fetchStaticsData();
    },
    fetchStaticsData() {
      const { storeId, tabs } = this;
      const { orderStartTime: startTime, orderEndTime: endTime } = type2Datetime(tabs);
      fetch.pc_inventory_supervision_laid_up_summary({ startTime, endTime, storeId }).then(res => {
        this.statics = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
